// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { Text } from '@mantine/core';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { TextareaWrapped } from 'components/Mantine/TextInputWrapped';
import type { WorkOrderActionModalProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/workOrderActions';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

export const RejectWorkOrderModal = ({ workOrder, onWorkOrderActioned, ...props }: WorkOrderActionModalProps) => {
  const { rejectWorkOrder } = useWorkOrders();
  const [rejectedReason, setRejectedReason] = useState('');

  const onSubmit = () => rejectWorkOrder(workOrder.workOrderId, rejectedReason).then(onWorkOrderActioned);

  return (
    <WrappedModal
      title="Reject work order"
      onConfirm={onSubmit}
      confirmationText="Reject"
      buttonColor="red"
      disabled={!rejectedReason.trim()}
      {...props}
    >
      <Text>
        Please provide a reason for rejecting <b>{workOrder.name}</b>.
      </Text>
      <TextareaWrapped
        label="Reason"
        placeholder="Required"
        required
        value={rejectedReason}
        onChange={setRejectedReason}
        maxLength={1000}
        autoFocus
        data-autofocus
      />
    </WrappedModal>
  );
};
